import { useMutation, useQueryClient } from '@tanstack/react-query';

import { fetchWithCsrfToken } from 'utils/fetchWrapper';

export interface IDeleteVideoVariables {
  videoType: string;
}

interface IDeleteVideoResponse {
  interviewUid: string;
  name: string;
  videoType: string;
}

const useDeleteVideo = (interviewUid: string) => {
  const queryClient = useQueryClient();
  const {
    mutateAsync: deleteVideo,
    data,
    isLoading,
    error,
  } = useMutation<IDeleteVideoResponse, Error, IDeleteVideoVariables>(
    ['deleteVideo'],
    async ({ videoType }) => {
      const body = {
        interview: interviewUid,
        video_type: videoType,
      };

      const response = await fetchWithCsrfToken<IDeleteVideoResponse>(
        'builder/async/assessment/delete_video',
        'POST',
        body
      );

      return response;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: ['getAssessmentStepDetails', interviewUid],
        });
        queryClient.invalidateQueries({
          queryKey: ['getVideoDetails', interviewUid],
        });
      },
    }
  );

  return {
    deleteVideo,
    data,
    isLoading,
    error,
  };
};

export default useDeleteVideo;
